<template>
<m-pageframe
    title="Calendar"
>
<v-container>

    <v-list-item
        v-for="(item, index) in pages"
        :key="index"
        v-on:click="onClickPage(item)"
    >
        <v-list-item-icon><v-icon>{{item.icon}}</v-icon></v-list-item-icon>
        <v-list-item-content>
            <v-list-item-title>{{item.title}}</v-list-item-title>
        </v-list-item-content>
        <v-list-item-icon><v-icon>mdi-arrow-right</v-icon></v-list-item-icon>
    </v-list-item>

</v-container>
</m-pageframe>
</template>

<script>
export default {
    data() {
        return {
            pages: [
                { 'title': 'Calendly Event Types', 'icon': 'mdi-cog', 'page': 'admin-calendly-event-types' },
                { 'title': 'Calendar Events', 'icon': 'mdi-calendar', 'page': 'admin-calendar-events'},
            ],
        }
    },

    methods: {
        onClickPage(page) {
            this.$router.push({
                'name': page.page,
                'params' : {
                }
            });
        }
    },
}
</script>

<style lang="scss" scoped>
</style>
